<template>
  <v-dialog
    :title="$t('message.entity.actions.invalidateStaffCredentials')"
    :value="active"
    icon="lock_outline"
    lazy
    max-width="500px"
    @input="close"
  >
    <ds-card>
      <ds-card-title
        icon="lock_outline"
      >
        {{ $t('message.entity.actions.invalidateStaffCredentials') }}
      </ds-card-title>


      <template v-if="result.success">
        <ds-text
          v-text="$t('message.login.invalidateStaffCredentials.success')"
        />
      </template>
      <template v-else-if="result.error">
        <ds-text
          v-text="$t('message.login.invalidateStaffCredentials.success')"
        />
      </template>
      <template v-else-if="staffHasGoogleAuthEnabled">
        <ds-text
          v-text="$t('message.login.invalidateStaffCredentials.staffHasGoogleAuthEnabled')"
        />
      </template>
      <template v-else>
        <ds-heading size="300">
          {{ $t('message.login.invalidateStaffCredentials.title') }}
        </ds-heading>
        <ds-text
          v-text="description"
        />
      </template>

      <ds-card-actions>
        <v-btn
          :loading="loading"
          color="primary"
          flat
          @click="close"
        >
          {{ closeButtonText }}
        </v-btn>
        <v-btn
          v-show="!staffHasGoogleAuthEnabled && !result.success && !result.error"
          :loading="loading"
          color="red"
          flat
          @click="invalidateStaffCredentials"
        >
          {{ $t('message.entity.actions.reset') }}
        </v-btn>
      </ds-card-actions>
    </ds-card>
  </v-dialog>
</template>

<script>
import StorableEditorComponent from '@/mixins/storable-editor-component';
import { mapGetters } from 'vuex';
import { TWO_FACTOR_AUTHENTICATION } from '@/features';
import get from 'lodash/get';

export default {
  name: 'NxEntityInvalidateStaffCredentialsAction',
  mixins: [StorableEditorComponent],
  data() {
    return {
      active: false,
      loading: false,
      result: {
        success: false,
        error: false,
      },
    };
  },
  computed: {
    ...mapGetters(['features']),
    staffHasGoogleAuthEnabled() {
      return Boolean(get(this.state, 'master.googleOauthEnabled', false));
    },
    closeButtonText() {
      if (this.staffHasGoogleAuthEnabled) {
        return this.$t('message.common.close');
      }
      return (this.result.success || this.result.error)
        ? this.$t('message.common.close')
        : this.$t('message.common.cancel');
    },
    description() {
      return this.features[TWO_FACTOR_AUTHENTICATION]
        ? this.$t('message.login.invalidateStaffCredentials.description2FA')
        : this.$t('message.login.invalidateStaffCredentials.description');
    },
  },
  async mounted() {
    this.active = true;
  },
  methods: {
    close() {
      this.active = false;
      this.$emit('close');
    },
    async invalidateStaffCredentials() {
      this.loading = true;
      try {
        await this.$store.dispatch('authentication/INVALIDATE_STAFF_CREDENTIALS', this.state.master.id);
        this.result.success = true;
      } catch (e) {
        this.result.error = true;
        console.warn('error invalidating staff credentials');
        console.error(e);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
